export enum CountryCode {
  FR = 'fr',
  ES = 'es',
  IT = 'it',
  FI = 'fi',
}
